import React from 'react';

export default function IndexTableFiltersPanelDate(props) {
    return (
        <div className="filters-panel-input">
            <span title={props.label}>{props.label}</span>
            <span>
                <input type="date"/>
            </span>
        </div>
    )
}